import React from 'react';

const Tutorial: React.FC = () => {
  return (
    <>
      <div className="row">
        <div className="col-12 col-md-4 arrow-container arrowtuto">
          <i className="fas fa-arrow-left arrow-tutorial"></i>
          <span className="arrow-tutorial-text">Tutorial</span>
        </div>
      </div>

      <div className="row">
        <div className="col-12 arrow-container arrowterminal">
          <i className="fas fa-arrow-left arrow-terminal"></i>
          <span className="arrow-terminal-text">
            En esta seccion pueder ejecutar tu codigo SQL directamente{' '}
            <strong>solo admite sentencias CREATE TABLE</strong>, puedes hacer un export de tus tablas
          </span>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8 arrow-container arrowsql">
          <i className="fas fa-arrow-left arrow-sql"></i>
          <span className="arrow-sql-text">
            <strong>¿Sin conocimiento en SQL?</strong> Genera tus tablas usando un formulario sencillo
          </span>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8 arrow-container arrowremote">
          <i className="fas fa-arrow-left arrow-remote"></i>
          <span className="arrow-sql-text">
            Conexion remota a tu servidor, no adminte localhost, no almacenamos tu informacion
          </span>
        </div>
      </div>
    </>
  );
};

export default Tutorial;